<template>
    <v-card flat tile height="100%" width="100%" class="transparent">
        <span class="switchlabel">{{label}}</span>
        <label class="switch d-flex flex-row align-center flex-nowrap" style="float:right;">
            <v-icon class="stepper-btn theme-back theme-border" @click="minus">mdi-minus</v-icon>
            <v-card class="transparent stepper-value theme-title" flat tile>{{value}}</v-card>
            <v-icon class="stepper-btn theme-back theme-border" @click="plus">mdi-plus</v-icon>
        </label>
    </v-card>
</template>

<script>
    export default {
        name: "Stepper",
        props: {
            label: String,
            min: Number,
            max: Number,
            value: Number,
        },
        methods: {
            minus() {
                let self = this;

                if(self.value > self.min) {
                    self.$emit('onvaluechange', self.value-1);
                }
            },
            plus() {
                let self = this;

                if(self.value < self.max) {
                    self.$emit('onvaluechange', self.value+1);
                }
            },
        }
    };
</script>

<style scoped>
    .switch {
        position: relative;
        display: inline-block;
        width: 70px;
        height: 24px;
        margin-left: 5px;
    }

    .switchlabel {
        height: 16px;
        font-size: 14px;
    }

    .stepper-value {
        line-height: 24px;
        width: 22px;
        text-align: center;
    }

    .stepper-btn {
        width: 24px;
        height: 24px;
        border-width: 1px;
        border-style: solid;
    }
</style>